module.exports = __webpack_public_path__ + "static/media/pipe_up.7e59b539.png";